import { ContentLoader } from "@rio-cloud/rio-uikit";

interface Props {
  rows: number;
  cols: number;
}

const TableRowLoading = ({ rows, cols }: Props) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex}>
          {Array.from({ length: cols }).map((_, colIndex) => (
            <td key={colIndex}>
              <ContentLoader />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export default TableRowLoading;
